<div class="widget-toggle-button" [class.is-active]="isActive">
  <fa-icon [icon]="['far', 'chevron-down']" [flip]="isActive && 'vertical'"></fa-icon>
</div>
